<template>
    <div class="wrap">
        <div class="pilihan">
            <button :class="[(showMain)?'act-menu':'']" @click="showMain = true; showPetugas = false" v-if="datauser.role_name == 'Supervisor'">Dashboard tiket</button>
            <button :class="[(showPetugas)?'act-menu':'']" @click="showPetugas = true; showMain = false">Kinerja petugas</button>
        </div>
        <div class="dash-report">
            <DashboardReportPetugas v-if="showPetugas && datauser.role_name == 'Agent'" />
            <SPVReport v-if="showPetugas && datauser.role_name == 'Supervisor'" />
            <DashboardReportMain v-if="showMain && datauser.role_name == 'Supervisor'" />
        </div>
    </div>
</template>

<style scoped>

    .wrap{
        display: grid;
        grid-template-rows: max-content auto;
        overflow: hidden;
        height: 100vh;
        

        .pilihan{
            button{
                border: none;
                background-color: white;
                border-bottom: 2px solid transparent;
                padding: 10px;
                font-family: poppins-reg;
                margin-left: 20px;
            }

            .act-menu{
                border-bottom: 2px solid #1869ff;
                color: #1869ff;
            }
        }
    }
</style>

<script>
import { getCookie } from '@/assets/config/cookie';
import DashboardReportMain from './DashboardReportMain.vue';
import DashboardReportPetugas from './DashboardReportPetugas.vue';
import SPVReport from './SPVReport.vue';

export default {
    name: "DashboardReport",
    components: {
        DashboardReportPetugas,
        DashboardReportMain,
        SPVReport
    },
    data() {
        return {
            showPetugas: false,
            showMain: true,
            datauser : {
                role_id : ""
            }
        }
    },
    updated() {

    },
    mounted() {
        const data = getCookie('loginInfo');
        this.datauser = JSON.parse(data)

        if(this.datauser.role_name == 'Agent'){
            this.showMain = false
            this.showPetugas = true
        }
    },
    methods: {

    }
}
</script>